
import { useState } from 'react';
import Layout from '../../components/base/Layout';

export default function Staff() {
  const [selectedStaff, setSelectedStaff] = useState<number | null>(null);

  const staffMembers = [
    {
      id: 1,
      name: '田中 美咲',
      position: 'トップスタイリスト',
      experience: '15年',
      specialty: 'カット・カラー・パーマ',
      message: 'お客様の魅力を最大限に引き出すスタイルをご提案いたします。髪質やライフスタイルに合わせたオーダーメイドのヘアスタイルで、毎日を素敵に過ごしていただけるよう心がけています。',
      qualifications: ['美容師免許', 'カラーリスト検定1級', 'パーマ技術認定'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20hair%20stylist%20portrait%20in%20modern%20salon%2C%20elegant%20black%20and%20white%20photography%2C%20confident%20and%20friendly%20expression%2C%20professional%20beauty%20industry%20worker%2C%20sophisticated%20salon%20environment%2C%20contemporary%20portrait%20style&width=300&height=400&seq=staff1&orientation=portrait'
    },
    {
      id: 2,
      name: '佐藤 健太',
      position: 'シニアスタイリスト',
      experience: '12年',
      specialty: 'メンズカット・デザインカラー',
      message: 'トレンドを取り入れながらも、お客様に似合うスタイルを大切にしています。特にメンズスタイルでは、ビジネスシーンからプライベートまで対応できる汎用性の高いスタイルを得意としています。',
      qualifications: ['美容師免許', 'メンズカット専門認定', 'デザインカラー検定'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20hair%20stylist%20portrait%20in%20contemporary%20salon%20setting%2C%20clean%20modern%20aesthetic%2C%20confident%20professional%20appearance%2C%20black%20and%20white%20photography%20style%2C%20sophisticated%20beauty%20industry%20professional&width=300&height=400&seq=staff2&orientation=portrait'
    },
    {
      id: 3,
      name: '山田 奈々',
      position: 'スタイリスト',
      experience: '8年',
      specialty: 'トリートメント・ヘッドスパ',
      message: '髪と頭皮の健康を第一に考えたケアを心がけています。お客様にリラックスしていただける空間作りと、髪質改善に特化した施術で、美しい髪を育むお手伝いをさせていただきます。',
      qualifications: ['美容師免許', 'ヘッドスパ認定', 'トリートメント専門資格'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20hair%20treatment%20specialist%20portrait%2C%20serene%20and%20gentle%20expression%2C%20modern%20beauty%20salon%20setting%2C%20black%20and%20white%20professional%20photography%2C%20expert%20in%20hair%20care%20and%20spa%20treatments&width=300&height=400&seq=staff3&orientation=portrait'
    }
  ];

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-4xl font-light text-black mb-6">
            Staff
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            経験豊富で技術力の高いスタイリストが、あなたの美しさを引き出します。<br />
            お客様一人ひとりに寄り添った丁寧な施術をお約束いたします。
          </p>
        </div>

        {/* Staff Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {staffMembers.map((staff) => (
            <div key={staff.id} className="text-center">
              <div 
                className="mb-6 cursor-pointer group"
                onClick={() => setSelectedStaff(staff.id)}
              >
                <img
                  src={staff.image}
                  alt={staff.name}
                  className="w-full h-80 object-cover object-top mb-4 group-hover:opacity-80 transition-opacity"
                />
                <h3 className="text-lg font-medium text-black mb-2 group-hover:text-gray-600 transition-colors">
                  {staff.name}
                </h3>
                <p className="text-gray-600 mb-1">{staff.position}</p>
                <p className="text-gray-500">経験年数: {staff.experience}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Staff Detail Modal */}
        {selectedStaff && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white max-w-2xl w-full max-h-screen overflow-y-auto">
              {(() => {
                const staff = staffMembers.find(s => s.id === selectedStaff);
                if (!staff) return null;
                
                return (
                  <div className="p-8">
                    <div className="flex justify-between items-start mb-6">
                      <h2 className="font-light text-black">
                        {staff.name}
                      </h2>
                      <button
                        onClick={() => setSelectedStaff(null)}
                        className="text-gray-500 hover:text-black transition-colors cursor-pointer"
                      >
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-close-line text-xl"></i>
                        </div>
                      </button>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <img
                          src={staff.image}
                          alt={staff.name}
                          className="w-full h-96 object-cover object-top mb-4"
                        />
                      </div>
                      
                      <div className="space-y-6">
                        <div>
                          <h3 className="font-medium text-black mb-2">ポジション</h3>
                          <p className="text-gray-700">{staff.position}</p>
                        </div>
                        
                        <div>
                          <h3 className="font-medium text-black mb-2">経験年数</h3>
                          <p className="text-gray-700">{staff.experience}</p>
                        </div>
                        
                        <div>
                          <h3 className="font-medium text-black mb-2">得意分野</h3>
                          <p className="text-gray-700">{staff.specialty}</p>
                        </div>
                        
                        <div>
                          <h3 className="font-medium text-black mb-2">保有資格</h3>
                          <div className="space-y-1">
                            {staff.qualifications.map((qualification, index) => (
                              <p key={index} className="text-gray-700">
                                • {qualification}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-8">
                      <h3 className="font-medium text-black mb-3">メッセージ</h3>
                      <p className="text-gray-700 leading-relaxed">
                        {staff.message}
                      </p>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
